<style lang="scss" scoped>
@use '~@/styles/base/variables';

@media screen and (min-width: variables.$medium) {
  $mini-dash-gap: 5px;

  .scroll-radius-fix {
    padding: 1px;
  }

  .btn {
    border: none;
    background: none;
    cursor: pointer;
    transition: 0.3s;
  }

  .dash {
    flex: auto;
    margin-left: -$mini-dash-gap;
    margin-right: -$mini-dash-gap;
    margin-top: -$mini-dash-gap;

    &_responsive {
      padding-bottom: 150px;
    }
  }

  .dash-item {
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 100%;
    border-radius: 5px;

    &_responsive {
      border: 2px solid #42b983;
    }

    &__wrapper {
      &_static {
        touch-action: initial !important;
        -webkit-user-select: initial !important;
        -moz-user-select: initial !important;
        -ms-user-select: initial !important;
        user-select: initial !important;
      }
    }

    &__header {
      position: absolute;
      width: calc(100% - 4px);
      height: 40px;
      background-color: #404364c2;
      display: flex;
      justify-content: center;
      align-items: center;
      z-index: 2;

      .drag-icon {
        fill: #e6e6e6;
      }

      .del {
        position: absolute;
        width: 30px;
        height: 30px;
        top: 50%;
        bottom: 50%;
        right: 10px;
        margin: auto 0;
        fill: var(--color-accent-light);

        &:hover {
          fill: var(--color-accent);
        }
      }
    }

    &__content {
      height: 100%;
      display: flex;
      flex-direction: column;

      &_responsive {
        z-index: -1;
        opacity: 0.8;
      }
    }

    &__resize {
      position: absolute;
      width: 20px;
      height: 20px;
      bottom: 0px;
      right: 0px;
      cursor: se-resize;

      &::after {
        content: '';
        position: absolute;
        right: 4px;
        bottom: 4px;
        width: 5px;
        height: 5px;
        border-right: 2px solid rgb(198, 202, 208);
        border-bottom: 2px solid rgb(198, 202, 208);
      }
    }
  }

  .dash-floating-panel {
    display: flex;
    position: fixed;
    flex-direction: column;
    align-items: center;
    bottom: -178px;
    right: 20px;
    gap: 5px;
    z-index: 2;

    &__btn {
      position: relative;
      display: flex;
      padding: 8px;
      border-radius: 50%;

      &:hover {
        box-shadow: 0px 0px 10px 5px #7d7d7d;
        &::before {
          position: absolute;
          content: attr(data-hint);
          color: var(--color-text-light);
          font-size: 16px;
          top: 20%;
          right: 120%;
          white-space: nowrap;
        }
      }

      &_save {
        width: 50px;
        height: 50px;
        background-color: var(--color-success-light);
      }

      &_default {
        width: 40px;
        height: 40px;
        background-color: var(--color-accent-light);
      }
    }

    &__hidden-dashitems {
      background-color: var(--color-accent-light);
      border-radius: 5px;
      margin-bottom: 10px;
    }
  }

  .bounce {
    animation: bounce 1s ease forwards;
  }

  @keyframes bounce {
    0% {
      transform: scale(1, 1);
      bottom: -178px;
    }
    10% {
      transform: scale(1.1, 0.9);
      bottom: -150px;
    }
    50% {
      transform: scale(0.9, 1.1);
      bottom: 150px;
    }
    100% {
      transform: scale(1, 1);
      bottom: 50px;
    }
  }
}

@media screen and (min-width: 1400px) {
  $dash-gap: 15px;

  .dash {
    margin-left: -$dash-gap;
    margin-right: -$dash-gap;
    margin-top: -$dash-gap;
  }
}
</style>

<template>
  <dashboard
    v-if="currentLayout"
    :id="'dashboard'"
    class="dash"
    :class="{ dash_responsive: isResponsive }"
  >
    <dash-layout v-bind="currentLayout">
      <dash-item
        v-for="(item, index) in currentLayout.items"
        v-bind.sync="item"
        :key="item.id"
        :class="{'dash-item__wrapper_static': !isResponsive}"
        @moveEnd="moveEnd()"
        @resizeEnd="resizeEnd()"
      >
        <div
          class="dash-item"
          :class="{ 'dash-item_responsive': isResponsive }"
        >
          <div
            v-show="isResponsive"
            class="dash-item__header"
          >
            <svg
              class="drag-icon"
              width="52"
              height="10"
              viewBox="0 0 52 10"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M14 6C15.1 6 16 6.9 16 8C16 9.1 15.1 10 14 10C12.9 10 12 9.1 12 8C12 6.9 12.9 6 14 6ZM6 8C6 9.1 6.9 10 8 10C9.1 10 10 9.1 10 8C10 6.9 9.1 6 8 6C6.9 6 6 6.9 6 8ZM0 8C0 9.1 0.9 10 2 10C3.1 10 4 9.1 4 8C4 6.9 3.1 6 2 6C0.9 6 0 6.9 0 8ZM4 2C4 0.9 3.1 0 2 0C0.9 0 0 0.9 0 2C0 3.1 0.9 4 2 4C3.1 4 4 3.1 4 2ZM6 2C6 3.1 6.9 4 8 4C9.1 4 10 3.1 10 2C10 0.9 9.1 0 8 0C6.9 0 6 0.9 6 2ZM12 2C12 3.1 12.9 4 14 4C15.1 4 16 3.1 16 2C16 0.9 15.1 0 14 0C12.9 0 12 0.9 12 2Z" />
              <path d="M32 6C33.1 6 34 6.9 34 8C34 9.1 33.1 10 32 10C30.9 10 30 9.1 30 8C30 6.9 30.9 6 32 6ZM24 8C24 9.1 24.9 10 26 10C27.1 10 28 9.1 28 8C28 6.9 27.1 6 26 6C24.9 6 24 6.9 24 8ZM18 8C18 9.1 18.9 10 20 10C21.1 10 22 9.1 22 8C22 6.9 21.1 6 20 6C18.9 6 18 6.9 18 8ZM22 2C22 0.9 21.1 0 20 0C18.9 0 18 0.9 18 2C18 3.1 18.9 4 20 4C21.1 4 22 3.1 22 2ZM24 2C24 3.1 24.9 4 26 4C27.1 4 28 3.1 28 2C28 0.9 27.1 0 26 0C24.9 0 24 0.9 24 2ZM30 2C30 3.1 30.9 4 32 4C33.1 4 34 3.1 34 2C34 0.9 33.1 0 32 0C30.9 0 30 0.9 30 2Z" />
              <path d="M50 6C51.1 6 52 6.9 52 8C52 9.1 51.1 10 50 10C48.9 10 48 9.1 48 8C48 6.9 48.9 6 50 6ZM42 8C42 9.1 42.9 10 44 10C45.1 10 46 9.1 46 8C46 6.9 45.1 6 44 6C42.9 6 42 6.9 42 8ZM36 8C36 9.1 36.9 10 38 10C39.1 10 40 9.1 40 8C40 6.9 39.1 6 38 6C36.9 6 36 6.9 36 8ZM40 2C40 0.9 39.1 0 38 0C36.9 0 36 0.9 36 2C36 3.1 36.9 4 38 4C39.1 4 40 3.1 40 2ZM42 2C42 3.1 42.9 4 44 4C45.1 4 46 3.1 46 2C46 0.9 45.1 0 44 0C42.9 0 42 0.9 42 2ZM48 2C48 3.1 48.9 4 50 4C51.1 4 52 3.1 52 2C52 0.9 51.1 0 50 0C48.9 0 48 0.9 48 2Z" />
            </svg>
            <button
              v-if="item.id !== 'SmartTrade' && !noDelete"
              class="btn del"
              @click="deleteDashItem(index)"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
              >
                <path d="M10.586 12L4.293 5.707 5 5l.707-.707L12 10.586l6.293-6.293L19 5l.707.707L13.414 12l6.293 6.293-1.414 1.414L12 13.414l-6.293 6.293L5 19l-.707-.707L10.586 12z"></path>
              </svg>
            </button>
          </div>
          <div
            class="dash-item__content"
            :class="{
                  'dash-item__content_responsive': isResponsive
                }"
          >
            <slot
              name="item"
              :item="item"
              :index="index"
              :currentLayout="currentLayout"
              :setDashboardToLocalStorage="setDashboardToLocalStorage"
            ></slot>
          </div>
        </div>
        <i
          v-show="!item.collapsed && isResponsive"
          class="dash-item__resize"
        ></i>
      </dash-item>
      <div
        v-if="isResponsive"
        class="dash-floating-panel bounce"
      >
        <ButtonGroup
          class="dash-floating-panel__hidden-dashitems"
          vertical
        >
          <Button
            v-for="(deletedItem, index) in currentLayout.deletedItems"
            :key="'deleted-' + deletedItem.id"
            @click="addDeletedDashItem(deletedItem, index)"
          >
            <Icon type="md-add"></Icon>
            {{ $text.tr(deletedItem.name) }}
          </Button>
        </ButtonGroup>
        <button
          :data-hint="$text.tr('СОХРАНИТЬ')"
          class="btn dash-floating-panel__btn dash-floating-panel__btn_save"
          @click="saveDashboard()"
        >
          <svg
            width="100%"
            height="100%"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
            fill="#ffffff"
          >
            <path
              d="M0 0h24v24H0z"
              fill="none"
            />
            <path d="M17 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V7l-4-4zm-5 16c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3zm3-10H5V5h10v4z" />
          </svg>
        </button>
        <button
          :data-hint="$text.tr('ПО УМОЛЧАНИЮ')"
          class="
                btn
                dash-floating-panel__btn dash-floating-panel__btn_default
              "
          @click="setDefaultDashboard()"
        >
          <svg
            width="100%"
            height="100%"
            viewBox="0 0 212 218"
            fill="#ffffff"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M187.431 108.8C187.431 112.54 187.204 116.053 186.751 119.453L209.531 137.36C211.684 138.947 212.251 141.78 210.891 144.273L189.131 181.9C187.771 184.393 184.937 185.3 182.444 184.393L155.357 173.513C149.804 177.82 143.684 181.447 136.997 184.167L132.917 212.953C132.577 215.673 130.311 217.6 127.591 217.6H84.0706C81.3506 217.6 79.1973 215.673 78.6307 212.953L74.5508 184.167C67.8641 181.447 61.8575 177.82 56.1907 173.513L29.1041 184.393C26.6106 185.187 23.7774 184.393 22.4173 181.9L0.657278 144.273C-0.589304 142.007 -0.0226536 138.947 2.01739 137.36L25.024 119.453C24.4573 116.053 24.2308 112.313 24.2308 108.8C24.2308 105.287 24.6841 101.547 25.2508 98.1466L2.24395 80.24C-0.0226536 78.6533 -0.476023 75.7067 0.884085 73.3267L22.5308 35.7C23.8907 33.2067 26.7242 32.3 29.2173 33.2067L56.304 44.0867C61.8575 39.8933 67.9773 36.1533 74.6641 33.4333L78.7439 4.64661C79.1973 1.92664 81.3506 0 84.0706 0H127.591C130.311 0 132.577 1.92664 133.031 4.64661L137.111 33.4333C143.797 36.1533 149.804 39.78 155.471 44.0867L182.557 33.2067C185.051 32.4133 187.884 33.2067 189.244 35.7L211.004 73.3267C212.251 75.5933 211.684 78.6533 209.644 80.24L186.638 98.1466C187.204 101.547 187.431 105.173 187.431 108.8ZM106.94 98.2037C100.279 97.86 94.5477 103.029 94.2039 109.69C93.8599 116.352 99.0289 122.083 105.69 122.427C112.352 122.771 118.083 117.602 118.427 110.941C118.771 104.279 113.602 98.5476 106.94 98.2037ZM160.818 113.128C162.371 83.0309 139.226 57.3663 109.128 55.813C79.0308 54.2596 53.3663 77.405 51.813 107.503C50.2596 137.6 73.4051 163.265 103.502 164.818C115.978 165.462 127.702 161.817 137.27 155.267L129.121 146.103C121.903 150.648 113.272 153.178 104.128 152.706C80.6915 151.497 62.7151 131.564 63.9246 108.128C65.1341 84.6915 85.0672 66.7151 108.503 67.9246C131.939 69.1342 149.916 89.0671 148.706 112.503L130.539 111.566L153.512 137.039L178.985 114.066L160.818 113.128Z"
            />
          </svg>
        </button>
      </div>
    </dash-layout>
  </dashboard>
</template>

<script>
import { Dashboard, DashLayout, DashItem } from 'capico-vue-responsive-dash'
import constants from '@/util/constants.js'

export default {
  props: {
    dashboard: {
      type: Array,
      required: true
    },
    value: {
      type: Boolean,
      default: undefined
    },
    localStorageKey: {
      type: String,
      required: true
    },
    defaultKey: {
      type: String,
      required: true
    },
    noDelete: {
      type: Boolean
    }
  },
  components: {
    Dashboard,
    DashLayout,
    DashItem
  },
  data () {
    return {}
  },
  watch: {
    isResponsive: function (value) {
      if (value) {
        this.changeDashboardState()
      } else {
        this.saveDashboard()
      }
    }
  },
  computed: {
    isResponsive: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    },
    currentLayoutIndex () {
      return this.dashboard.findIndex(
        layout => layout.breakpoint === this.$store.state.sys.breakpoint
      )
    },
    currentLayout () {
      this.$emit(
        'update:currentLayout',
        this.dashboard[this.currentLayoutIndex]
      )
      return this.dashboard[this.currentLayoutIndex]
    }
  },
  created () {
    if (!this.dashboard.length) {
      this.setDashboard()
    }
  },
  methods: {
    moveEnd () {
      this.$nextTick(() => {
        this.setDashboardToLocalStorage()
      })
    },
    resizeEnd () {
      this.$nextTick(() => {
        this.setDashboardToLocalStorage()
      })
    },
    setDashboard () {
      try {
        const dash = localStorage.getItem(this.localStorageKey)

        if (dash) {
          this.$emit('update:dashboard', JSON.parse(dash))
        } else {
          this.setDefaultDashboard()
        }
      } catch (e) {
        console.log(e)
        this.setDefaultDashboard()
      }
    },
    setDefaultDashboard () {
      this.$emit('update:dashboard', JSON.parse(constants[this.defaultKey]))

      this.$nextTick(() => {
        this.changeDashboardState()
      })
    },
    changeDashboardState () {
      if (this.isResponsive === undefined) {
        return
      }

      this.dashboard.forEach(layout => {
        layout.items.forEach(item => {
          item.locked = !this.isResponsive
        })
      })
    },
    setDashboardToLocalStorage () {
      localStorage.setItem(this.localStorageKey, JSON.stringify(this.dashboard))
    },
    saveDashboard () {
      this.isResponsive = false
      this.changeDashboardState()
      this.setDashboardToLocalStorage()
    },
    deleteDashItem (index) {
      const deletedItem = this.currentLayout.items.splice(index, 1)

      this.currentLayout.deletedItems.push(deletedItem[0])
    },
    addDashItem () {
      deletedItem.y = this.getBiggestItemHeight(this.currentLayoutIndex)

      this.currentLayout.items.push(deletedItem)
      this.currentLayout.deletedItems.splice(index, 1)
    },
    addDeletedDashItem (deletedItem, index) {
      deletedItem.y = this.getBiggestItemHeight(this.currentLayoutIndex)

      this.currentLayout.items.push(deletedItem)
      this.currentLayout.deletedItems.splice(index, 1)
    },
    getBiggestItemHeight () {
      let maxHeight = 0

      this.currentLayout.items.forEach(currentItem => {
        const totalCurrentHeight = currentItem.y + currentItem.height

        if (totalCurrentHeight > maxHeight) {
          maxHeight = totalCurrentHeight
        }
      })

      return maxHeight
    }
  }
}
</script>
